import { Header } from './components';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';

type LayoutPropsType = {
  authenticated: boolean;
};

export function Layout({ authenticated }: LayoutPropsType) {
  return (
    <>
      {authenticated && <Header />}
      <Container component='main' maxWidth={false} sx={{ margin: '104px 0px 40px 0px' }}>
        <Outlet />
      </Container>
    </>
  );
}
